import type React from "react";

export type ColorDisplayFormat = "css" | "hex" | "hsb" | "hsl" | "rgb";

export const selectAllOnFocus: React.FocusEventHandler<HTMLInputElement> = (
	e,
) => e.target.select();
